<ion-header class="ion-no-border">
  <ion-toolbar class="glass-panel">
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()" class="neon-btn mini">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="neon-text">CREDENTIAL AUDIT: {{ driverName | uppercase }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- Loading State -->
  <div *ngIf="isLoading">
    <ion-card *ngFor="let i of [1,2,3]">
      <ion-card-header>
        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </ion-card-header>
      <ion-card-content>
        <ion-skeleton-text animated style="width: 100%; height: 100px;"></ion-skeleton-text>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- No Data State -->
  <div *ngIf="!isLoading && hasNoData" class="ion-text-center ion-padding">
    <ion-icon name="document-outline" style="font-size: 64px; color: var(--ion-color-medium);"></ion-icon>
    <h3>No Documents Found</h3>
    <p>This driver has not submitted any documents yet.</p>
  </div>

  <!-- Documents List -->
  <div *ngIf="!isLoading && !hasNoData" class="document-list">
    <div *ngFor="let document of records" class="glass-card neon-border document-card-wrapper">
      <div class="card-header">
        <div class="type-icon">
          <ion-icon [name]="getDocumentIcon(document.type)" class="neon-text"></ion-icon>
        </div>
        <div class="title-section">
          <h3 class="neon-text-small">{{ document.name | uppercase }}</h3>
          <div class="status-row">
            <ion-badge [color]="getStatusColor(document.status)" class="neon-badge">
              {{ document.status || 'PENDING' }}
            </ion-badge>
            <small class="type-tag">{{ document.type | uppercase }}</small>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!-- Text Content -->
        <div *ngIf="document.type === 'text'" class="text-preview glass-inset">
          <p>{{ document.value || document.content || document.text }}</p>
        </div>

        <!-- Image Content -->
        <div *ngIf="document.type === 'image'" class="image-preview">
          <img [src]="document.value || document.image || document.content"
            (click)="openDocument(document.value || document.image || document.content)" class="neon-glow-img">
        </div>

        <!-- PDF Content -->
        <div *ngIf="document.type === 'pdf'" class="pdf-preview">
          <ion-button expand="block" class="neon-btn tertiary"
            (click)="openDocument(document.value || document.content)">
            <ion-icon name="eye-outline" slot="start"></ion-icon>
            ACCESS ENCRYPTED PDF
          </ion-button>
        </div>

        <div class="rejection-box glass-card danger" *ngIf="document.status === 'Rejected' && document.reason">
          <ion-icon name="warning-outline"></ion-icon>
          <span>REJECTION REASON: {{ document.reason }}</span>
        </div>
      </div>

      <div class="card-footer">
        <div class="meta-info">
          <ion-icon name="time-outline"></ion-icon>
          <span>LOGGED: {{ (document.date?.toDate ? document.date.toDate() : document.date) | date:'short' }}</span>
        </div>
        <div class="audit-actions" *ngIf="document.status !== 'Approved'">
          <ion-button (click)="rejectDocument(document)" fill="clear" class="neon-btn mini danger">
            <ion-icon name="close-circle-outline" slot="start"></ion-icon>
            DENY
          </ion-button>
          <ion-button (click)="approveDocument(document)" fill="clear" class="neon-btn mini success">
            <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
            AUTHORIZE
          </ion-button>
        </div>
        <div class="audit-verified" *ngIf="document.status === 'Approved'">
          <ion-icon name="shield-checkmark-outline"></ion-icon>
          <span>DOCUMENTS APPROVED</span>
        </div>
      </div>
    </div>
  </div>
</ion-content>